import SvgIconStyle from "~components/SvgIconStyle";

// ----------------------------------------------------------------------

export const getIcon = (name: string) => (
  <SvgIconStyle
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);
